import { cn } from "@/lib/utils";

type InlineQuoteProps = {
  authorName: string;
  content: string;
  isDeleted: boolean;
  onClick?: () => void;
};

export function InlineQuote({
  authorName,
  content,
  isDeleted,
  onClick,
}: InlineQuoteProps) {
  return (
    <div
      className={cn(
        "bg-muted/50 rounded-lg px-3 py-2 border-l-2 border-primary mb-1",
        onClick && "cursor-pointer hover:bg-muted/70 transition-colors"
      )}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      aria-label={onClick ? `Scroll to original message from ${authorName}` : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      {isDeleted ? (
        <p className="text-xs italic text-muted-foreground">[Message deleted]</p>
      ) : (
        <>
          {authorName && (
            <p className="text-xs font-semibold text-foreground">{authorName}</p>
          )}
          <p className="text-xs text-muted-foreground line-clamp-2">{content}</p>
        </>
      )}
    </div>
  );
}
